import { Box } from "@mui/system";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { RouteParamsProvider } from "../context/RouteParamsProvider";
import { SelectedOptionsProvider } from "../context/SelectedOptionsContext";
import { Analytics } from "@vercel/analytics/react";

import "./index.css";
import styles from "./app.module.scss";

import { WrapperUI } from "../components/WrapperUI";

const theme = createTheme({
  typography: {
    fontFamily:
      '"Onest", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
    color: "#ffffff !important",
  },
  // Extra safety: reinforce on <body> via CssBaseline
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily:
            '"Onest", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
        },
      },
    },
  },
  borderRadius: {
    small: "2px",
    medium: "8px",
    big: "16px",
  },
  palette: {
    companyColors: {
      black: "#000000",
      blackRGB: "0,0,0",
      accent: "#c70000",
      accentRGB: "199,0,0",
      secondary: "#ffffff",
      secondaryRGB: "255,255,255",
      greyLight1: "#A3A3A0",
      greyLight2: "#D9D9D9",
      greyLight3: "#E8E8E8",
      darkGrey1: "#0d0e10",
      darkGrey2: "#1a1c1e",
      darkGrey3: "#222529",
      opacity0: 0,
      opacity25: 0.25,
      opacity50: 0.5,
      opacity75: 0.75,
    },
  },
});

export function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Analytics />
      <SelectedOptionsProvider>
        <Box className={styles.app}>
          <Router>
            <Routes>
              <Route
                path="/"
                element={
                  <RouteParamsProvider>
                    <WrapperUI />
                  </RouteParamsProvider>
                }
              />
              <Route
                path="/:configCode"
                element={
                  <RouteParamsProvider>
                    <WrapperUI />
                  </RouteParamsProvider>
                }
              />
            </Routes>
          </Router>
        </Box>
      </SelectedOptionsProvider>
    </ThemeProvider>
  );
}

export default App;
